import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, withRouter } from 'react-router-dom';
import { HelperFunctions, IndexJs } from '@westernmilling/react_component_library';

import App from 'App';

HelperFunctions.suppressConsoleMessages();

const container = document.getElementById('root');
const root = createRoot(container);
const AppWithRouterAccess = withRouter(App);

if (!window.location.pathname.includes('mywm')) {
  window.history.replaceState('', '', `/${process.env.REACT_APP_BASENAME}`);
}

root.render(
  <IndexJs app={<BrowserRouter basename={process.env.REACT_APP_BASENAME}><AppWithRouterAccess /></BrowserRouter>} />,
);
